/**
 * function appears to be a utility function designed to ensure that a given number (val) is represented as a string with a fixed length.
 * @param val The number that you want to format as a string.
 * @param numLen (optional, default is 2): The desired length of the resulting string.
 * @returns The result is a string with a length of at least numLen. If the length of the concatenated string exceeds numLen, the slicing operation ensures that only the last numLen characters are retained.
 */
var getFixedLengthNumString = function (val, numLen) {
    if (numLen === void 0) { numLen = 2; }
    return "00".concat(val).slice(-1 * numLen);
};
/**
 * function is designed to round a given number (value) to a specified number of decimal places (places).
 * @param value (number): The number that you want to round off.
 * @param places (number): The number of decimal places to round the value to.
 * @returns result is a string representation of the rounded number with the specified number of decimal places.
 */
var roundOffToDecimalPlaces = function (value, places) {
    return (Math.round(value * 100) / 100).toFixed(places);
};

export { getFixedLengthNumString, roundOffToDecimalPlaces };
//# sourceMappingURL=number.js.map
